import React from 'react';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import Link from '@components/atoms/link/link';
import { Breadcrumb } from '@interfaces/models/breadcrumb';
import BreadcrumbSchema from '@components/structured-schemas/breadcrumb-schema';
import styles from './breadcrumbs.module.scss';

export interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  isCatalogPage: boolean;
  customClass?: string;
  dataCyIdentifier?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = (props) => {
  const { breadcrumbs, isCatalogPage, customClass, dataCyIdentifier = 'breadcrumbs-list' } = props;

  const { pathname } = useRouter();

  const length = breadcrumbs.length;

  // Determines if selected url is current url
  const isActiveItem = (path: string): boolean => {
    return pathname === path;
  };

  const isLastItem = (index: number): boolean => {
    return length === index + 1;
  };

  return (
    <>
      <BreadcrumbSchema breadcrumbs={breadcrumbs} />
      {breadcrumbs.length > 0 && (
        <ol
          className={clsx(styles.mainBreadcrumb, customClass)}
          data-cy={dataCyIdentifier}
        >
          {breadcrumbs.map((breadcrumb: Breadcrumb, index: number) => (
            <li
              // eslint-disable-next-line react/no-array-index-key -- Array keys are okay here, this never changes.
              key={index}
              className={clsx(styles.mainBreadcrumb__item, {
                [styles['mainBreadcrumb__item--notActive']]: isActiveItem(breadcrumb.url.path),
              })}
            >
              {!isActiveItem(breadcrumb.url.path) && !isLastItem(index) && (
                <Link href={breadcrumb?.url.path}>{breadcrumb.localizedName}</Link>
              )}
              {isCatalogPage && isLastItem(index) && (
                <h1 className={styles.mainBreadcrumb__h1}>{breadcrumb.localizedName}</h1>
              )}
              {!isCatalogPage && isLastItem(index) && <span>{breadcrumb.localizedName}</span>}
            </li>
          ))}
        </ol>
      )}
    </>
  );
};

export default Breadcrumbs;
